import React, { useRef } from "react";
import { BiImageAdd } from "react-icons/bi";
import { BsExclamationCircleFill } from "react-icons/bs";
import { FcAddImage } from "react-icons/fc";
import { FaRegEdit } from "react-icons/fa";


const CityImageUpload = ({
  filesHandler,
  files,
  imageUrl,
  imageUrlHandler,
}) => {
  const hiddenFileInput = useRef(null);
  const handleClick = (e) => {
    hiddenFileInput.current.click();
  };

  function handleImageChange(e) {
    filesHandler(e.target.files[0]);
    imageUrlHandler(URL.createObjectURL(e.target.files[0]))
  }
  return (
    <div className="upload-city-img-wrapper ">
      <div className="cursor-pointer" onClick={handleClick}>
        <div className="update-city-edit-btn">
          <FaRegEdit  className="actions-icons  cursor-pointer"/>
        </div>
        <div className="main-image main-img-box city-image-box">
          {
            !imageUrl ? (
              <div className="no-image-placeholder d-flex flex-column justify-content-center align-items-center">
                <FcAddImage size={60} />
                <span className="mt-2">Add City Image</span>
              </div>
            ) : <img src={imageUrl} alt="Selected" />
          }
          
        </div>
        <div>
          <input
            id="image-upload-input"
            type="file"
            onChange={handleImageChange}
            ref={hiddenFileInput}
            className="image-upload-input"
            accept="image/png , image/jpeg, image/webp"
          />
        </div>
      </div>
      {/* <div>
        <span className="lable-para">
          {`You are allowed to uploads files with the following formates : `}
          <span className="label-star">{" JPG/JPEG/PNG "}</span>
          {` The maximum image size is permitted is `}
          <span className="label-star">{" 20 MB "}</span>
          {` maintain a consistent of 1:1 aspect ratio for images`}
        </span>
      </div> */}
      {/* <div className="img-guildlines">
        <span>
          <BsExclamationCircleFill />
        </span>
        <p className="img-guildlines-para">
          {
            "You are allowed to uploads files with the following formates : JPG/JPEG/PNG . The maximum image size is permitted is 20 MB maintain a consistent of 1:1 aspect ratio for images."
          }
        </p>
      </div> */}
    </div>
  );
};

export default CityImageUpload;
